<template>
  <form>
    <md-card v-if="clientAcc">
      <md-card-header
        class="md-card-header-icon"
        :class="getClass(headerColor)"
      >
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 class="title">
          Cliente: <small>{{ clientAcc.fullName }}</small>
        </h4>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Documento</label>
              <md-input disabled v-model="clientAcc.documentValue"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Fecha de Expedición</label>
              <md-input disabled v-model="clientAcc.documentExpDate"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Ciudad de Expedición </label>
              <md-input
                disabled
                v-model="clientAcc.capCityDocExp.cityName"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Correo: {{ clientAcc.email }}</label>
              <md-input v-model="email" type="email"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Celular</label>
              <md-input
                disabled
                v-model="clientAcc.cellphone"
                type="email"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Fecha de Cumpleaños</label>
              <md-input
                disabled
                v-bind:value="clientAcc.birthDate"
                type="text"
              ></md-input>
            </md-field>
          </div>
        </div>
        <div v-if="clientAcc.capProfile" class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Número de Cuenta Bancaria</label>
              <md-input
                disabled
                v-model="
                  clientAcc.capProfile.capProfileBanks[0].bankAccountNumber
                "
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Tipo de Cuenta</label>
              <md-input
                disabled
                v-model="
                  clientAcc.capProfile.capProfileBanks[0].bankAccountType
                "
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Banco</label>
              <md-input
                disabled
                v-model="
                  clientAcc.capProfile.capProfileBanks[0].capDomain.fieldValue
                "
                type="text"
              ></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Teléfono</label>
              <md-input
                disabled
                v-model="clientAcc.capProfile.phoneNumber"
                type="email"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Dirección de Residencia</label>
              <md-input
                disabled
                v-model="clientAcc.capProfile.residenceAddress"
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Ciudad de Residencia</label>
              <md-input
                disabled
                v-model="clientAcc.capProfile.capCityResidence.cityName"
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Departamento</label>
              <md-input
                disabled
                v-model="
                  clientAcc.capProfile.capCityResidence.capDepartment.depName
                "
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Tiempo viviendo ahí (años)</label>
              <md-input
                disabled
                v-bind:value="clientAcc.capProfile.timeLiving"
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Número de hijos</label>
              <md-input
                disabled
                v-model="clientAcc.capProfile.childrenNumber"
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Número de Personas a Cargo</label>
              <md-input
                disabled
                v-model="clientAcc.capProfile.numberPeopleInCharge"
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Estado civil</label>
              <md-input
                disabled
                v-bind:value="
                  clientAcc.capProfile.capDomainCivilStatus.fieldValue
                "
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Placa del vehículo</label>
              <md-input
                disabled
                v-bind:value="
                  clientAcc.capProfile.vehiclePlate
                    ? clientAcc.capProfile.vehiclePlate
                    : 'No tiene'
                "
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Tiene tarjeta de crédito</label>
              <md-input
                disabled
                v-bind:value="
                  clientAcc.capProfile.hasCredictCard == 1 ? 'Sí' : 'No'
                "
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Nivel de estudio</label>
              <md-input
                disabled
                v-bind:value="
                  clientAcc.capProfile.capDomainStudyLevel.fieldValue
                "
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Empresa en la que trabaja</label>
              <md-input
                disabled
                v-bind:value="
                  clientAcc.capProfile.capClientJobs[0].enterpriseName
                "
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Correo de la empresa</label>
              <md-input
                disabled
                v-bind:value="
                  clientAcc.capProfile.capClientJobs[0].enterpriseEmail
                "
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Nit de la empresa</label>
              <md-input
                disabled
                v-bind:value="
                  clientAcc.capProfile.capClientJobs[0].enterpriseNit
                "
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Teléfono de la empresa</label>
              <md-input
                disabled
                v-bind:value="
                  clientAcc.capProfile.capClientJobs[0].enterprisePhone
                "
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Extensión de la empresa</label>
              <md-input
                disabled
                v-bind:value="
                  clientAcc.capProfile.capClientJobs[0].enterprisePhoneExt
                "
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Cargo en la Empresa</label>
              <md-input
                disabled
                v-bind:value="clientAcc.capProfile.capClientJobs[0].jobRole"
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Tipo de contrato</label>
              <md-input
                disabled
                v-bind:value="
                  clientAcc.capProfile.capClientJobs[0].capDomainContractType
                    .fieldValue
                "
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Sector de la empresa</label>
              <md-input
                disabled
                v-bind:value="
                  clientAcc.capProfile.capClientJobs[0]
                    .capDomainEnterpriseSector.fieldValue
                "
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Días de pago</label>
              <md-input
                disabled
                v-bind:value="clientAcc.capProfile.paymentDays"
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Cómo conoció CAPITAL77</label>
              <md-input
                disabled
                v-bind:value="
                  clientAcc.capProfile.capDomainHowKnowCap.fieldValue
                "
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Nombre de Referencia Familiar</label>
              <md-input
                disabled
                v-bind:value="
                  clientAcc.capProfile.refFamiliarName +
                    ' ' +
                    clientAcc.capProfile.refFamiliarLastName
                "
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Celular de Referencia Familiar</label>
              <md-input
                disabled
                v-bind:value="clientAcc.capProfile.refFamililarCellphone"
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Tipo de Relación</label>
              <md-input
                disabled
                v-bind:value="
                  clientAcc.capProfile.capDomainRefFRelation.fieldValue
                "
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Nombre de Referencia Personal</label>
              <md-input
                disabled
                v-bind:value="
                  clientAcc.capProfile.refPersonalName +
                    ' ' +
                    clientAcc.capProfile.refPersonalLastName
                "
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Celular de Referencia Personal</label>
              <md-input
                disabled
                v-bind:value="clientAcc.capProfile.refPersonalCellphone"
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Tipo de Relación</label>
              <md-input
                disabled
                v-bind:value="
                  clientAcc.capProfile.capDomainRefPRelation.fieldValue
                "
                type="text"
              ></md-input>
            </md-field>
          </div>
        </div>
        <div v-else class="md-layout-item md-size-100">
          <h6>Perfil no registrado</h6>
        </div>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Estado del cliente</label>
              <md-input
                disabled
                v-model="clientAcc.capCurrentStatus.stateName"
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-33 md-small-size-100">
            <md-field class="md-layout-item" v-if="statusList">
              <label for="pages">Cambiar estado a</label>
              <md-select v-model="status" name="pages">
                <md-option
                  v-for="item in statusList"
                  :key="item.id"
                  :value="item.id"
                  >{{ item.name }}
                </md-option>
              </md-select>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Categoría</label>
              <md-input
                disabled
                v-bind:value="clientAcc.capClientCategory.catName"
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-33 md-small-size-100">
            <ValidationProvider
              name="documentValue"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <md-field
                :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
              >
                <label v-if="currentScore"
                  >Puntaje: {{ currentScore.score }}</label
                >
                <md-input v-model="score" type="number"></md-input>
              </md-field>
            </ValidationProvider>
          </div>
          <div class="md-layout-item md-size-100 md-small-size-100">
            <label>Puntaje</label>
            <vue-slider v-bind="options" v-model="score"></vue-slider>
          </div>
          <div class="md-layout-item md-size-100 text-right">
            <md-button @click="updateClient()" class="md-raised md-success mt-4"
              >Guardar</md-button
            >
          </div>
        </div>
      </md-card-content>
    </md-card>
    <div v-if="clientAcc" class="md-layout">
      <div :class="classDivFile">
        <PictureSelect
          :fileReason="Constants.KEY_NAME_REASON_DOCUMENT_PICTURE"
          :updatable="false"
          :userId="clientAcc.accountId"
        />
      </div>
      <div :class="classDivFile">
        <PictureSelect
          :fileReason="Constants.KEY_NAME_REASON_RECOGNITION_PICTURE"
          :updatable="false"
          :userId="clientAcc.accountId"
        />
      </div>
      <div :class="classDivFile">
        <PictureSelect
          :fileReason="Constants.KEY_NAME_REASON_BANK_CERTIFICATE"
          :updatable="false"
          :userId="clientAcc.accountId"
        />
      </div>

      <div :class="classDivFile">
        <PictureSelect
          :fileReason="Constants.KEY_NAME_REASON_WORK_CERTIFICATE"
          :updatable="false"
          :userId="clientAcc.accountId"
        />
      </div>
      <div :class="classDivFile">
        <PictureSelect
          :fileReason="Constants.KEY_NAME_REASON_PAY_STUB"
          :updatable="false"
          :userId="clientAcc.accountId"
        />
      </div>
    </div>
  </form>
</template>
<script>
import gql from "graphql-tag";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import Swal from "sweetalert2";
import Constants from "../../constants";
import PictureSelect from "../components/PictureSelect.vue";
export default {
  components: {
    VueSlider,
    PictureSelect
  },
  name: "edit-profile-form",
  props: {
    headerColor: {
      type: String,
      default: "blue"
    }
  },
  data() {
    return {
      clientAcc: null,
      options: {
        min: 1,
        max: 100,
        interval: 0.1,
        adsorb: true
      },
      email: null,
      status: null,
      score: null,
      statusList: null,
      currentScore: null,
      Constants: Constants,
      classDivFile:
        "md-layout-item text-center md-size-25 mx-auto md-xsmall-size-100"
    };
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    getName() {
      return "Cliente X";
    },
    buildConfirmationMessage() {
      var message = "¿Seguro que deseas actualizar el/los campo(s) ";
      var isFirst = true;
      if (this.email) {
        message += "Correo electrónico";
        isFirst = false;
      }
      if (this.status) {
        if (!isFirst) message += ", ";
        else isFirst = false;
        message += "Estado actual";
      }
      if (this.score != this.currentScore.score) {
        if (!isFirst) message += ", ";
        else isFirst = false;
        message += "Puntaje";
      }
      return message + " de " + this.clientAcc.fullName + ".";
    },
    updateClient() {
      if (this.email || this.status || this.score != this.currentScore.score) {
        Swal.fire({
          title: "Confirmación de actualización",
          text: this.buildConfirmationMessage(),
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-primary",
          cancelButtonClass: "md-button md-info",
          confirmButtonText: "Sí",
          cancelButtonText: "No",
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.$apollo
              .mutate({
                mutation: gql`
                  mutation updateClientInformation(
                    $documentValue: String!
                    $email: String
                    $status: Int
                    $score: Float
                  ) {
                    updateClientInformation(
                      documentValue: $documentValue
                      email: $email
                      status: $status
                      score: $score
                    )
                  }
                `,
                variables: {
                  documentValue: this.clientAcc.documentValue,
                  email: this.email,
                  status: this.status,
                  score: this.score
                },
                update: (cache, mutationResult) => {
                  Swal.fire({
                    title: "Cliente actualizado",
                    text:
                      "Se ha actualizado correctamente el cliente " +
                      this.clientAcc.fullName +
                      ".",
                    confirmButtonClass: "md-button md-primary",
                    buttonsStyling: false
                  }).then(() => {
                    this.$router.go();
                  });
                }
              })
              .catch(error => {
                Constants.catchError(
                  error,
                  this.$apollo.provider.defaultClient,
                  this
                );
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
          }
        });
      } else
        Swal.fire({
          title: "No hay cambios",
          text: "Modifica el/los datos que deseas actualizar",
          timer: 2000,
          showConfirmButton: false
        });
    }
  },
  mounted() {
    this.$apollo
      .query({
        query: gql`
          query findAccountById($id: Int!) {
            findAccountById(id: $id) {
              accountId
              fullName
              email
              cellphone
              diffScore
              capCurrentStatus {
                stateId
                stateName
              }
              capProfile {
                residenceAddress
                capDomainCivilStatus {
                  fieldValue
                }
                capDomainHowKnowCap {
                  fieldValue
                }
                capDomainStudyLevel {
                  fieldValue
                }
                capClientJobs {
                  enterpriseEmail
                  enterpriseName
                  enterpriseNit
                  enterprisePhone
                  enterprisePhoneExt
                  jobRole
                  yearsExperience
                  capDomainContractType {
                    fieldValue
                  }
                  capDomainEnterpriseSector {
                    fieldValue
                  }
                }
                capProfileBanks {
                  bankAccountNumber
                  bankAccountType
                  capDomain {
                    fieldValue
                  }
                }
                capCityResidence {
                  cityName
                  capDepartment {
                    depName
                  }
                }
                childrenNumber
                hasCredictCard
                numberPeopleInCharge
                paymentDays
                phoneNumber
                refFamiliarName
                refFamiliarLastName
                refFamililarCellphone
                capDomainRefFRelation {
                  fieldValue
                }
                capDomainRefPRelation {
                  fieldValue
                }
                refPersonalCellphone
                refPersonalName
                refPersonalLastName
                timeLiving
                vehiclePlate
              }
              documentValue
              documentExpDate
              capCityDocExp {
                cityName
              }
              birthDate
              capClientCategory {
                catName
              }
            }
          }
        `,
        variables: {
          id: this.$route.params.clientId
        }
      })
      .then(data => {
        this.clientAcc = data.data.findAccountById;
        this.$apollo
          .query({
            query: gql`
              query getFromToCurrentStateCredit($currentState: Int!) {
                getFromToCurrentStateCredit(currentState: $currentState) {
                  id: stateId
                  name: stateName
                  description: stateDescription
                }
              }
            `,
            variables: {
              currentState: this.clientAcc.capCurrentStatus.stateId
            }
          })
          .then(data => {
            this.statusList = data.data.getFromToCurrentStateCredit;
          })
          .catch(error => {
            Constants.catchError(
              error,
              this.$apollo.provider.defaultClient,
              this
            );
          });
        this.$apollo
          .query({
            query: gql`
              query findScoreFromAccount($accountId: Int!) {
                findScoreFromAccount(accountId: $accountId) {
                  accountId
                  score
                }
              }
            `,
            variables: {
              accountId: this.$route.params.clientId
            }
          })
          .then(data => {
            this.currentScore = data.data.findScoreFromAccount;
            this.score = this.currentScore.score;
          })
          .catch(error => {
            Constants.catchError(
              error,
              this.$apollo.provider.defaultClient,
              this
            );
          });
      })
      .catch(error => {
        Constants.catchError(error, this.$apollo.provider.defaultClient, this);
      });
  }
};
</script>
<style></style>
